//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconNavBlogFill(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M22 4H14V20H22V4Z" fill="currentColor" /><path d="M12 4H2V12H12V4Z" fill="currentColor" /><path d="M12 14H2V16H12V14Z" fill="currentColor" /><path d="M12 18H2V20H12V18Z" fill="currentColor" /></svg>;
}
export default IconNavBlogFill;